var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.023,
    height: 22.023,
    viewBox: "0 0 22.023 22.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M11.011,20.646a9.635,9.635,0,1,1,9.635-9.635A9.635,9.635,0,0,1,11.011,20.646Zm0,1.376A11.011,11.011,0,1,0,0,11.011,11.011,11.011,0,0,0,11.011,22.023Z",
    fill: "#757ea5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M81.345,46.25l-3.152.4-.113.523.619.114c.4.1.484.242.4.646L78.08,52.7c-.267,1.235.145,1.816,1.112,1.816a2.85,2.85,0,0,0,2.016-.823l.121-.573a1.525,1.525,0,0,1-.944.339c-.379,0-.516-.266-.418-.734Zm.1-2.874A1.376,1.376,0,1,1,80.065,42,1.376,1.376,0,0,1,81.442,43.376Z",
    transform: "translate(-69.054 -37.183)",
    fill: "#757ea5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskInfo);
export default __webpack_public_path__ + "static/media/task-info.0111c9271731a40cc750932d99d3dd66.svg";
export { ForwardRef as ReactComponent };